export default "__VITE_ASSET__CAW366Wa__";